<template>
    <div :style="cssProps" class="separator">{{ text }}</div>
</template>

<script>
export default {
    name: "separator",
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            require: false,
            default: "#000"
        }
    },
    data: function() {
        return {
            customColor: this.color
        }
   },
    computed: {
        cssProps() {
        return {
            '--custom-color': this.customColor,
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.separator {
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--custom-color);
}

.separator::before,
.separator::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid var(--custom-color);
}

.separator:not(:empty)::before {
    margin-right: 0.25em;
}

.separator:not(:empty)::after {
    margin-left: 0.25em;
}
</style>